const about = require('./about')
const myTokens = require('./myTokens')
const marketplace = require('./marketplace')
const createOrder = require('./createOrder')
const myOrders = require('./myOrders')
const ordersForMe = require('./ordersForMe')

module.exports = {
  about,
  myTokens,
  marketplace,
  createOrder,
  myOrders,
  ordersForMe
}

